/** @jsx h */

import { h, Component } from 'preact';
import cx from 'classnames';
import DatePicker from "./DatePicker";
// import '../../../styles/datepicker.css';

import type {
  DateRangeInputCSSClasses,
  DateRangeInputTemplates,
} from '../../widgets/date-range-input/date-range-input';
import type {
  RangeBoundaries,
} from '../../connectors/range/connectRange';
import type { ComponentCSSClasses } from '../../types';
import {RangeInputProps} from "../RangeInput/RangeInput";

export type DateRangeInputComponentCSSClasses =
  ComponentCSSClasses<DateRangeInputCSSClasses>;

export type DateRangeInputComponentTemplates = Required<DateRangeInputTemplates>;

export type DateRangeInputProps = {
  min?: number;
  max?: number;
  step: number;
  datePickerOpenedMin: boolean;
  datePickerOpenedMax: boolean;
  cssClasses: DateRangeInputComponentCSSClasses;
  templateProps: {
    templates: DateRangeInputComponentTemplates;
  };
  refine(rangeValue: RangeBoundaries): void;
};

class DateRangeInput extends Component<RangeInputProps> {

  openDatePickerMin() {
    this.setState({
      datePickerOpenedMin: true
    });
  }

  openDatePickerMax() {
    this.setState({
      datePickerOpenedMax: true
    });
  }

  closeDatePickerMin() {
    this.setState({
      datePickerOpenedMin: false
    });
  }

  closeDatePickerMax() {
    this.setState({
      datePickerOpenedMax: false
    });
  }

  private onSubmit = (event: Event) => {
    event.preventDefault();
    this.props.refine([this.state.min, this.state.max]);
  };

  /**
   * Gets passed to DatePicker and fired when date is selected and 'OK' is clicked.
   * @param {object} date the date object of the selected date
   */
  dateReceiverMin(date) {
    let timestamp = ((date.getTime()-(date.getTime()%1000)) / 1000)
    this.setState({ pickedDate: date });
    this.setState({ minValue: date, min:  timestamp});
  }
  dateReceiverMax(date) {
    let timestamp = ((date.getTime()-(date.getTime()%1000)) / 1000)
    this.setState({ pickedDate: date });
    this.setState({ maxValue: date, max:  timestamp});
  }

  constructor() {
    super();

    this.state = {
      datePickerOpenedMin: false,
      datePickerOpenedMax: false,
    }

    this.openDatePickerMin = this.openDatePickerMin.bind(this);
    this.openDatePickerMax = this.openDatePickerMax.bind(this);
    this.closeDatePickerMin = this.closeDatePickerMin.bind(this);
    this.closeDatePickerMax = this.closeDatePickerMax.bind(this);
    this.dateReceiverMin = this.dateReceiverMin.bind(this);
    this.dateReceiverMax = this.dateReceiverMax.bind(this);

  }

  render() {

    const {
      datePickerOpenedMin,
      datePickerOpenedMax,
    } = this.state;
    const { min: minValue, max: maxValue } = this.state;
    const { min, max, step, cssClasses } = this.props;
    const hasRefinements = Boolean(minValue || maxValue);
    const isDisabled = minValue && maxValue ? minValue > maxValue : false;
    const rootClassNames = cx(cssClasses.root, {
      [cssClasses.noRefinement]: !hasRefinements,
    });


    return (

      <div className={rootClassNames}>
        <b>Erscheinungs­datum</b><br />
        <input onClick={this.openDatePickerMin} value={this.state.minValue ? this.state.minValue.toLocaleDateString('de-CH') : 'Von'} />
        <input onClick={this.openDatePickerMax} value={this.state.maxValue ? this.state.maxValue.toLocaleDateString('de-CH') : 'Bis'} />

        {/*   THE DATEPICKER:   */}
        <DatePicker closeFunction={this.closeDatePickerMin} opened={datePickerOpenedMin} dateReceiver={this.dateReceiverMin} />
        <DatePicker closeFunction={this.closeDatePickerMax} opened={datePickerOpenedMax} dateReceiver={this.dateReceiverMax} />

        <button type="submit" disabled={isDisabled} onClick={this.onSubmit}>Anzeigen</button>
      </div>
    )
  }

}

export default DateRangeInput;
